(function () {
    "use strict";

    // @ngInject
    function ContactsControllerCtor($scope, $q, $window, $injector, $stateParams, $timeout, ContactsManager, UsersManager, ModelFactory, UserService, AnalyticsService, UIUtils, _, PopupMessageService, ModalService, ngToast, ToastService, FeaturesService, PendingTasksManager, $translate, UiPersistenceService, Enums, AppStates) {

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'ContactsController';
        this.UsersManager = UsersManager;
        this.ContactsManager = ContactsManager;
        this.$timeout = $timeout;
        this.UserService = UserService;
        this.AnalyticsService = AnalyticsService;
        this.UIUtils = UIUtils;
        this.$q = $q;
        this._ = _;
        this.PopupMessageService = PopupMessageService;
        this.PendingTasksManager = PendingTasksManager;
        this.ModalService = ModalService;
        this.ModelFactory = ModelFactory;
        this.ngToast = ngToast;
        this.ToastService = ToastService;
        this.$translate = $translate;
        this.Enums = Enums;
        this.AppStates = AppStates;

        this.contacts = ModelFactory.newContactsCollection();
        this.user = UsersManager.getCurrUser();
        this.page = 1;
        this.totalPages = 1;
        this.contactsPerPage = 30;

        /* batch actions and filters */
        this.filters = {};
        this.selectedContacts = [];
        this.undeletableContacts = [];
        this.MAX_CONTACTS_PER_BATCH = 100;
        this.allContactsChecked = false;
        this.isSendingBulkEmail = false;

        this.filteredContactsCount = 0;
        this.lastFetchedContactName = null;
        this.lastFetchedContactId = null;
        this.UiPersistenceService = UiPersistenceService;

        this.AnalyticsService.trackPageView(this, this.AnalyticsService.analytics_events.contacts_page);
        this.FeaturesService = FeaturesService;

        this.filters.text = $stateParams.search || '';


        if ($stateParams.googleIntegrationCreated) {
            this.ModalService.openGoogleContactsModal(this.addGoogleContact.bind(this), 'Add', true, true, 'contacts', 'add contact');
        }

        var tempSearchText = '',
            searchTimeout;

        $scope.$watch('contactsVm.filters.text', function (val) {
            if (searchTimeout) {
                $timeout.cancel(searchTimeout);
            }

            tempSearchText = val;
            searchTimeout = $timeout(function () {
                this.filters.text = tempSearchText;
                this.onContactsFilterChanged();
            }.bind(this), 800); // delay 800 ms
        }.bind(this));

        $scope.$watchCollection('contactsVm.contacts', function () {
            this.groupedContacts = this.groupContacts();
        }.bind(this));

        this.$scope.$on('broadcastContactsAdded', function(event, data) {
            this.onContactsFilterChanged();
        }.bind(this));


        /* sticky header */
        angular.element($window).on('scroll', this.headerScroll);

        $scope.$on('$destroy', function () {
            angular.element($window).off('scroll');
        }.bind(this));

        this.initFilters();
    }


    Controllers.ContactsController = Class(Controllers.BaseController, {

        constructor: ContactsControllerCtor,

        initFilters: function initFilters(){
            var filterList = {
                hasProject: {
                    title: 'With project',
                    name: 'has_project'
                },
                noProject: {
                    title: 'Without project',
                    name: 'no_project'
                },
                hasCompany: {
                    title: 'Company info',
                    name: 'has_company'
                },
                isPreferred: {
                    title: 'Preferred vendor',
                    name: 'is_preferred'
                }
            };

            var filtersListGiftCard = {
                giftCardLead:{
                    title: "Gift card lead",
                    name: 'gift_card_lead'
                },
                giftCardPurchased: {
                    title: 'Gift card purchased',
                    name: 'git_card_purchased'
                },
                giftCardRedeemed: {
                    title: 'Gift card redeemed',
                    name: 'git_card_redeemed'
                }
            };

            if (this.user.isFeatureActive(this.FeaturesService.rolloutFeatures.instantBookingGiftCards)) {
                this.filtersList = this._.extend(filterList, filtersListGiftCard);
            } else {
                this.filtersList = filterList;
            }
        },

        getContacts: function getContacts() {
            if(this.page <= this.totalPages) {
                this.loadingContacts = true;
                this.filters.last_fetched_name = this.lastFetchedContactName;
                this.filters.last_fetched_id = this.lastFetchedContactId;
                this.ContactsManager.getUserContacts(this.contacts, this.user, this.page, this.filters, this.contactsPerPage)
                    .then(function onSuccess(resp) {
                        this.page++;
                        this.totalPages = resp.data.total_pages;
                        this.filteredContactsCount = resp.data.total_contacts;
                        var lastFetchedContact = this.contacts[this.contacts.length - 1];
                        if(lastFetchedContact){
                            this.lastFetchedContactName = lastFetchedContact.details.first_name + " " + lastFetchedContact.details.last_name;
                            this.lastFetchedContactId = lastFetchedContact._id;
                        }
                    }.bind(this))
                    .finally(function onFinally() {
                        this.loadingContacts = false;
                    }.bind(this));
            }
        },

        loadMoreContacts: function loadMoreContacts() {
            if(!this.loadingContacts) {
                this.getContacts();
            }
        },

        onContactsFilterChanged: function onContactsFilterChanged() {
            this.page = 1;
            this.totalPages = 1;
            this.contacts.clear();
            this.groupedContacts = {};
            this.getContacts();
        },

        clearSearch: function clearSearch() {
            this.filters.text = '';
        },

        resetSearchAndFilters: function resetSearchAndFilters() {
            this.filters = {};
            this.filters.is_preferred = false;
            this.filters.workspaces_count = false;
            this.clearSearch();
            this.onContactsFilterChanged();
        },

        groupContacts: function groupContacts() {
            return this._.groupBy(this.contacts, function (contact) {
                var catagory = 'N/A (other)';
                if (contact.user.full_name && contact.user.full_name.length > 0) {
                    catagory = contact.user.full_name.charAt(0).toUpperCase();
                }
                return catagory;
            });
        },

        addContactClicked: function addContactClicked() {
            // Toast configuration
            var toastIcon = '<span class="icon icon-hb-nx-participants"></span>';
            var toastText = ' added successfully!';
            var toastTimeout = 1000;

            this.AnalyticsService.trackClick(this, 'add client');
            this.UserService.addContact().then(function(contact) {
                var user = contact.user;
                this.$timeout( function () {
                    var userNameSafeString = this.UIUtils.sanitize(user.full_name);

                    this.ngToast.create({
                        content: toastIcon + userNameSafeString + toastText,
                        className: 'success',
                        dismissOnTimeout: true,
                        dismissButton: true
                    });
                }.bind(this), toastTimeout);

                // emit name for header nav title, via network controller broadcast
                this.$scope.$emit('emitContactsAdded', contact);
            }.bind(this));
        },

        onGoogleSyncBtnClicked: function onGoogleSyncBtnClicked() {
            //analytics move here because they need to act different, sending too many args for them to match the other "add gmail integration" events that we have.
            if (this.user.isGoogleIntegrationActive('contacts')){
                this.AnalyticsService.trackClick(this, 'open google contacts', {source: "second_level_nav", type: "contacts", app_path: "second_level_nav", event: "open google contacts", eventType: "click"});
                this.openGoogleContactsModal();
            }
            else{
                this.AnalyticsService.trackClick(this, 'add gmail integration', {source: "second_level_nav", type: "contacts", app_path: "second_level_nav", event: "add gmail integration", eventType: "click"});
                this.UserService.connectToAGoogleAccount(null, 'contacts');
            }

            this.UserService.syncGoogleContactClicked();
        },

        openGoogleContactsModal: function openGoogleContactsModal() {
            this.ModalService.openGoogleContactsModal(this.addGoogleContact.bind(this), 'Add', true, true, 'contacts', 'add contact');
        },

        addGoogleContact: function addGoogleContact(contact) {
            var trackingArgs = {
                email: contact.user.email,
                type: contact.user.system_user_type,
                from: 'google'
            };

            this.ContactsManager.saveJSONContact(contact)
                .then(function onSuccess(resp) {
                    contact.added = true;

                    this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.save_contact, trackingArgs);

                    var contactModel = resp.model;

                    this.contacts.push(contactModel);

                    // Kind of a HACK - we reload the specific contact to get it with the image after it was saved to S3
                    this.$timeout(function () {
                        var contacts = this.ModelFactory.newContactsCollection();
                        this.ContactsManager.getUserContacts(contacts, this.user, 1, {text: contactModel.user.email}).then(function () {

                            if (contacts.length === 1) {
                                this.contacts.splice(this.contacts.indexOf(contactModel), 1);
                                this.contacts.push(contacts[0]);
                            }
                        }.bind(this));
                    }.bind(this), 300);
                }.bind(this))
                .catch(function onFailure(resp) {
                    this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.save_contact_unsuccessful, trackingArgs);
                    var msg;
                    if (resp && resp.responseJSON && resp.responseJSON.error_message) {
                        msg = resp.responseJSON.error_message;
                    } else {
                        msg = 'CONTACTS.GOOGLE.GOOGLE_API._UNKNOWN_ERROR_';
                    }
                    this.PopupMessageService.showErrorAlert(msg);
                });
        },

        onUploadContactsModal: function onUploadContactsModal() {
            this.ModalService.openUploadClientsModal('upload');
        },

        isActiveFilter: function isActiveFilter() {
            var activeFilter = this._.some(this.filters, function (filter) {
                return filter === true;
            });

            return (this.filters.text && this.filters.text.length > 1) || activeFilter;
        },

        toggleFilter: function toggleFilter(name) {
            this.filters[name] = !this.filters[name];
            this.onContactsFilterChanged();
        },

        afterDeleteContact: function afterDeleteContact(contact) {
            this.contacts.splice(this.contacts.indexOf(contact), 1);
            this.filteredContactsCount--;
        },

        handleFilter: function handleFilter(filter){
            this.toggleFilter(filter.name)
        },

        headerScroll: function headerScroll() {
            var header = angular.element('.contacts__header');
            if (this.pageYOffset > 137) {
                header.addClass('contacts__header--sticky');
            } else {
                header.removeClass('contacts__header--sticky');
            }
        },

        onContactSelect : function onContactSelect(contact) {
            var contactId = contact._id;
            var indexContact = this.selectedContacts.indexOf(contact);

            if (indexContact === -1){
               this.selectedContacts.push(contact);
            } else {
                this.selectedContacts.splice(indexContact, 1);
            }

            if (!contact.deletable) {
                var indexUndeletable = this.undeletableContacts.indexOf(contactId);
                if (indexUndeletable === -1) {
                    this.undeletableContacts.push(contactId);
                } else {
                    this.undeletableContacts.splice(indexUndeletable, 1);
                }
            }
        },

        isContactSelected: function isContactSelected(contact){
            return this.selectedContacts.indexOf(contact) !== -1;
        },

        onClearSelectedContacts: function onClearSelectedContacts(){
            this.selectedContacts.splice(0);
            this.undeletableContacts.splice(0);
            this.allContactsChecked = false;
        },

        onSelectAllContacts: function onSelectAllContacts(){
            this.allContactsChecked = !this.allContactsChecked;
            this.selectedContacts.splice(0);
            this.undeletableContacts.splice(0);

            if (this.allContactsChecked) {
                this.contacts.forEach(function(contact) {
                    this.selectedContacts.push(contact);
                    if (!contact.deletable) {
                        this.undeletableContacts.push(contact._id);
                    }
                }.bind(this));
            }
        },

        _deletableEmails: function _deletableEmails(){
            var deletable = this.selectedContacts.filter(function (contact) {
                return this.undeletableContacts.indexOf(contact._id) === -1;
            }.bind(this));
            return deletable.length;
        },

        _trackingBulkDeleteSuceess: function _trackingBulkDeleteSuceess(res) {
            var trackingArgs = {
                action: 'bulk delete',
                failed: res.failed.length,
                succeed: res.successful.length
            };

            this.AnalyticsService.trackSuccess(this, this.AnalyticsService.analytics_events.contacts_bulk_action, trackingArgs);
        },

        _trackingBulkDeleteError: function _trackingBulkDeleteError(err) {
            var errorMsg = err || 'delete bulk contacts error';
            this.AnalyticsService.trackError(this, this.AnalyticsService.analytics_events.contacts_bulk_action, {action: 'delete', error_message: errorMsg});
        },

        _onBulkDeleteSuccess: function _onBulkDeleteSuccess(res){
            this.onContactsFilterChanged();
            this.onClearSelectedContacts();
            this._trackingBulkDeleteSuceess(res);

            var deleteSuccessMessage = this.$translate.instant('CONTACTS.BULK._DELETE_TOAST_SUCCESS_', {
                contact_count: res.successful.length,
                plural: res.successful.length > 1 ? 's' : ''
            });

            if (res.successful.length) {
                this.$timeout(function () {
                    this.ToastService.showSuccess({
                        contentTranslation: deleteSuccessMessage,
                        iconCssClass: 'icon icon-hb-nx-check-mark-circle-16',
                        dismissOnTimeout: true,
                        dismissButton: true,
                        timeout:5000
                    });
                }.bind(this), 1000);
            }
        },

        _handleDeleteSelectedContacts: function _handleDeleteSelectedContacts() {
            this.loadingContacts = true;

            var selectedContactsIds = this._.map(this.selectedContacts, function (contact) {
                return contact._id;
            }.bind(this));

            this.PendingTasksManager.createPendingTask(this.PendingTasksManager.pendingTasksTypes.deleteContacts, {
                user_id: this.user._id,
                contact_ids: selectedContactsIds
            }).then(function success(res) {
                this._onBulkDeleteSuccess(res);
            }.bind(this)).catch(function(err) {
                this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.error, 'ERRORS.SERVER_API._UNEXPECTED_');
                this._trackingBulkDeleteError(err);
                this.loadingContacts = false;
            }.bind(this)).finally(function () {
                this.resetSearchAndFilters();
            }.bind(this));
        },

        onDeleteBulkContacts: function onDeleteBulkContacts(){
            if ( this.loadingContacts ) {
                return;
            }

            var deletableEmails = this._deletableEmails();

            if (!deletableEmails){
                return this.PopupMessageService.showAlert(
                  this.PopupMessageService.severityTypes.warning,
                  this.$translate.instant('CONTACTS.POPUPS.DELETE._CONTACT_FROM_WS_CANNOT_DELETED_'));
            }

            var warningMessage = this.$translate.instant('CONTACTS.POPUPS.DELETE._MESSAGE_', {
                contact_count: deletableEmails,
                plural: deletableEmails > 1 ? 's' : '',
            });

            var undeletableWarning = this.undeletableContacts.length ?
              this.$translate.instant('CONTACTS.POPUPS.DELETE._CANNOT_DELETE_SOME_', {
                  contact_count: this.undeletableContacts.length,
                  plural: this.undeletableContacts.length > 1 ? 's' : '',
                  is_are: this.undeletableContacts.length > 1 ? 'are' : 'is'
              }) : '';


            this.PopupMessageService.showConfirmPromise(
              this.PopupMessageService.severityTypes.warning,
              warningMessage + undeletableWarning,
              'CONTACTS.POPUPS.DELETE._CONFIRM_',
              'FREQUENT_BUTTONS._CANCEL_')
              .then(function onConfirm() {
                  this._handleDeleteSelectedContacts();
                  this.AnalyticsService.trackConfirm(this, this.AnalyticsService.analytics_events.delete_contacts_confirm);
              }.bind(this))
              .catch(function () {
                  this.AnalyticsService.trackCancel(this, this.AnalyticsService.analytics_events.delete_contacts_cancel);
              }.bind(this));
        },

        _showGmailIntegraionConfirmModal: function _showGmailIntegraionConfirmModal() {
            this.PopupMessageService.showConfirmPromise(
              this.PopupMessageService.severityTypes.info,
              "BULK_EMAILS_ERRORS._GMAIL_",
              "BULK_EMAILS_ERRORS._GMAIL_CTA_POSITIVE_",
              "BULK_EMAILS_ERRORS._GMAIL_CTA_NEGATIVE_"
            )
              .then(function clickedPositiveBtn() {
                  this.AnalyticsService.trackClick(this, "go to gmail integration");
                  this.goToState(this.AppStates.root_core_navigation_settings_company_integrations);
              }.bind(this));
        },

        _openEmailTemplatesModal: function _openEmailTemplatesModal() {
            return this.ModalService.openEmailTemplatesModal();
        },

        _sendBulkEmail: function _sendBulkEmail(users, subject, body) {
            this.UiPersistenceService.setUiPersistence(this.UiPersistenceService.keys.bulkEmailIntro, {seen: true});

            var data = {
                user_id: this.user._id,
                recipient_user_ids: users,
                subject: subject,
                html_body: body,
                testEmail: false
            };

          return this.PendingTasksManager.createPendingTask(this.PendingTasksManager.pendingTasksTypes.sendBatchEmail, data).then(function success(resp) {
                  this._onBulkEmailsSent();
          }.bind(this));
        },

        _onBulkEmailsSent: function _onBulkEmailsSent() {
            this.AnalyticsService.trackSuccess(this, this.AnalyticsService.analytics_events.batch_emails_send_test_email_to_myself);

            this.ToastService.showSuccess({
                contentTranslation: 'BATCH_EMAILS.TOAST_SUCCESS',
                iconCssClass: 'icon icon-hb-nx-check-mark-circle-16',
                dismissOnTimeout: true,
                dismissButton: true,
                timeout: 5000
            });

        },

        _openEmailEditorModal: function _openEmailEditorModal(resolvedObject) {
            var config = {
                sendBulkToContacts: this.selectedContacts.length,
                selectedTemplateId: resolvedObject.templateId,
                dontLoopOverRecipients: true,
                editorType: "bulk contacts email",
                sendAsync: true
            };

            var selectedUserIds = this._.map(this.selectedContacts, function (contact) {
                return contact.user_id;
            }.bind(this));

            var options  = {
                users: selectedUserIds,
                subject: '',
                body: '',
                senderFunction: this._sendBulkEmail.bind(this),
                config: config
            };

            return this.ModalService.openEmailEditorModal(options);
        },


        _showBulkIntroModal: function _showBulkIntroModal() {
            var deferred = this.$q.defer();

            var seenBulkEmailIntro = this.UiPersistenceService.getUiPersistence(this.UiPersistenceService.keys.bulkEmailIntro, {seen: false}).seen;
            if (!seenBulkEmailIntro) {
                return this.ModalService.openBulkEmailsIntroModal('contacts');
            } else {
                deferred.resolve();
            }

            return this.$q.when();
        },

        _handleReject: function _handleReject(reason) {
            if (reason) {
                this.AnalyticsService.trackError(this, this.AnalyticsService.analytics_events.bulk_contacts_email, null, {error: reason});
                switch (reason) {

                    case this.Enums.isAllowedBulkEmails.gmailIntegraion:
                        this._showGmailIntegraionConfirmModal();
                        break;
                    case this.Enums.isAllowedBulkEmails.premiumFeatureOnly:
                        this.PopupMessageService.showAlertPromise(this.PopupMessageService.severityTypes.error, 'BULK_EMAILS_ERRORS._PREMIUM_', 'Upgrade Now').then(function() {
                            this.goToState(this.AppStates.root_core_navigation_settings_company_subscription);
                        }.bind(this));
                        break;
                    case this.Enums.isAllowedBulkEmails.maxDailyPassed:
                        this.PopupMessageService.showErrorAlert('BULK_EMAILS_ERRORS._MAX_DAILY_');
                        break;
                    case this.Enums.isAllowedBulkEmails.notAllowed:
                        this.PopupMessageService.showErrorAlert('BULK_EMAILS_ERRORS._NOT_ALLOWED_');
                        break;
                    case this.Enums.isAllowedBulkEmails.runningTask:
                        this.PopupMessageService.showErrorAlert('BULK_EMAILS_ERRORS._RUNNING_TASK_');
                        break;
                    case this.Enums.isAllowedBulkEmails.maxProjectsPerBatchExceeded:
                        this.PopupMessageService.showErrorAlert(this.$translate.instant('BULK_EMAILS_ERRORS._MAX_CONTACTS_PER_BATCH_EXCEEDED_', {limit: this.MAX_CONTACTS_PER_BATCH, delta:   this.selectedContacts.length - this.MAX_CONTACTS_PER_BATCH }));
                        break;
                    default:
                        break;
                }
            }
        },

        _isAllowedBulkEmails: function _isAllowedBulkEmails() {
            var deferred = this.$q.defer();

            if (this.selectedContacts.length > this.MAX_CONTACTS_PER_BATCH) {
                deferred.reject(this.Enums.isAllowedBulkEmails.maxProjectsPerBatchExceeded);
            } else {
                this.UsersManager.getBatchEmails(this.user._id).then(function(response) {
                    if (response.data.allowed) {
                        deferred.resolve();
                    } else {
                        switch (response.data.reason) {
                            case 'unsupported_email_intg':
                            case 'gmail_is_not_selected':
                                deferred.reject(this.Enums.isAllowedBulkEmails.gmailIntegraion);
                                break;
                            case 'premium_feature_only':
                                deferred.reject(this.Enums.isAllowedBulkEmails.premiumFeatureOnly);
                                break;
                            case 'max_daily_passed':
                            case 'cannot_send_more_then_twice_a_day':
                                deferred.reject(this.Enums.isAllowedBulkEmails.maxDailyPassed);
                                break;
                            case 'running_task':
                                deferred.reject(this.Enums.isAllowedBulkEmails.runningTask);
                                break;
                            default:
                                deferred.reject(this.Enums.isAllowedBulkEmails.notAllowed);
                                break;
                        }
                    }
                }.bind(this)).catch(function() {
                    this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.error, 'ERRORS.SERVER_API._COULD_NOT_CONNECT_TO_SERVER_');
                    deferred.reject(this.Enums.isAllowedBulkEmails.notAllowed);
                }.bind(this));
            }

            return deferred.promise;
        },

        onSendBulkMail: function onSendBulkMail() {
            if (!this.isSendingBulkEmail) {
                this.isSendingBulkEmail = true;
                this._isAllowedBulkEmails()
                    .then(this._showBulkIntroModal.bind(this))
                    .then(this._openEmailTemplatesModal.bind(this))
                    .then(this._openEmailEditorModal.bind(this))
                    .then(this.onClearSelectedContacts.bind(this))
                    .catch(this._handleReject.bind(this))
                    .finally(function () {
                        this.isSendingBulkEmail = false;
                    }.bind(this));
            }


        },

    });
}());
